<template>
  <div class="my-3">
    <CFormInput
      :value="value"
      placeholder="請填入數字 Please enter a number"
      :disabled="+info.is_help"
      v-model="contentNumber"
      @change="ChangeNumber"
      oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/,'$1')"
    />
  </div>
</template>
<script>
import { ref, watch, onMounted } from '@vue/runtime-core'
export default {
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['content'],
  setup(props, { emit }) {
    const contentNumber = ref(null)
    const ChangeNumber = ($event) => {
      if ($event?.target?.value) {
        $event.target.value = `${Number($event.target.value)}`
      }
      setTimeout(() => {
        emitContent();
      }, 1);
    };
    const emitContent = async() => {
      emit('content', {
        part_item_id: props.info.part_item_id,
        type: props.info.type,
        is_help: +props.info.is_help ? '1' : '0',
        help_message: props.info?.help_message ||'',
        is_finish: contentNumber.value !== null,
        value_info: !+props.info.is_help ? contentNumber.value : '',
      })
    }
    onMounted(() => {
      emitContent()
    })
    watch(
      () => props.info.value_info,
      (newValue) => {
        contentNumber.value = newValue
        emitContent()
      },
      { immediate: true },
    )
    watch(
      () => props.info.is_help,
      () => {
        emitContent()
      },
    )
    return {
      ChangeNumber,
      emitContent,
      contentNumber,
    }
  },
}
</script>
